import { useEffect, useRef } from 'react';
import type { IndexStatus } from '../types/index';

/** The model pass states after which the index has billed what it will bill for its version. */
const SETTLED = new Set<IndexStatus['model_pass']['state']>(['done', 'failed', 'skipped']);

/** Re-reads the usage once per index version whose model pass has finished. The pass bills the user (sculpt-api
 *  `PURPOSE_INDEX`, written before the version is marked understood) and nothing streams that spend to the pane: the
 *  bar used to show the figure from before the first indexation until the next turn or the minute's poll. */
export function useUsageAfterIndex(status: IndexStatus | null, refresh: () => Promise<void>): void {
  const key = status && SETTLED.has(status.model_pass.state) ? `${status.workbook_id}:${status.version}` : null;
  const seen = useRef<string | null>(null);
  useEffect(() => {
    if (key === null || key === seen.current) return;
    seen.current = key;
    void refresh();
  }, [key, refresh]);
}
